import { JobRequest } from "../../entities/JobRequest";
import { Helpers } from "../../../jobs-flow/Helpers";
import { Invoice } from "../../entities/Invoice";
import PriceBook from "../../../price-book";
import { InputSelector } from "../../../components/InputSelector";
import { InvoiceItem } from "../../entities/InvoiceItem";
import { Customer } from "../../entities/Customer";
import { SaveButton } from "../../../components/SaveButton";

export const QuoteInvoiceFormInterface = {

    itemSelector:null,
    customerSelector:null,

    checkAdditionalFields() {
        const formId = this.form.getAttribute('id');
        this.calculateTotalPriceInForm(formId.replace('-container', ''));
        Helpers.checkAdditionalAttributes();
    },

    setCustomerSelector(){
        this.customerSelector = new InputSelector('#customer-select')
        $('#customer-select .no-data-plus').addClass('d-none')
        $(this.customerSelector.element).on('select-item', (ev) => {
            const form = $(ev.target).parents('.form-container').find('form');
            this.checkIsDisabledBtns(form.attr('id'));
        })
        $(this.customerSelector.element).on('no-data', (ev) => {
            if (ev.originalEvent.detail.value) {
                $(this.customerSelector.noDataElement).find('.no-data-text').html(`<span>Create new customer <b>${ev.originalEvent.detail.value}</b></span>`)
            }
        })
        $('.create-new-customer-button').on('click', (e) => {
            if (this.customerSelector.selectedValueField)
                $(this.customerSelector.selectedValueField).attr('disabled', true)
            let inputValue = this.customerSelector.inputField.value.split(/\s+/)
            if (inputValue.length) {
                $(`#select-customer-for-invoice input[name="first_name"]`).val(inputValue[0])
                $(`#select-customer-for-invoice input[name="last_name"]`).val(inputValue?.[1] ?? '')
            }
            this.customerSelector.inputField.value = ''
            this.customerSelector.toggleList(false)
            this.customerSelector.filterItems()
            e.preventDefault();
            $('.create-new-customer').toggleClass('d-none');
        });

        $('#select-customer-for-invoice-modal button[data-save]').on('click',()=>{
            const SaveBtn = new SaveButton('#select-customer-for-invoice-modal');
            if (!$('.create-new-customer').hasClass('d-none')) {
                let validateResult = Customer.validateNewCustomer();
                if (validateResult) {
                    let form = $('#select-customer-for-invoice')
                    let first_name = $(`.create-new-customer [name='first_name']`).val();
                    let last_name = $(`.create-new-customer [name='last_name']`).val();
                    let formData = form.serialize();
                    $.ajax({
                        url: `${(new Customer()).urlRoot}/create`,
                        method: 'PUT',
                        data: formData,
                        beforeSend: () => {
                            SaveBtn.startLoading();
                        },
                        success: (response) => {
                            SaveBtn.stopLoading(true, 'Select').then(() => {
                                SaveBtn.showSuccess().then(() => {
                                    setTimeout(() => {
                                        const customerId = response.id;
                                        $('#customer-id').val(customerId);
                                        $('.customer-data-field .data.customer').text(`${first_name} ${last_name}`)
                                        // Save customer_id to localStorage for quote creation
                                        if (window.location.pathname.includes('/jobs-flow/quote/create')) {
                                            localStorage.setItem('quoteCreateCustomerId', customerId);
                                        }
                                        // Update InputSelector if it exists
                                        if (this.customerSelector) {
                                            const $hiddenInput = $(this.customerSelector.selectedValueField);
                                            if ($hiddenInput.length) {
                                                $hiddenInput.val(customerId);
                                            }
                                            if (this.customerSelector.inputField) {
                                                this.customerSelector.inputField.value = `${first_name} ${last_name}`;
                                                this.customerSelector.inputField.setAttribute('data-selected-value', customerId);
                                            }
                                            this.customerSelector.selectedValue = customerId;
                                        }
                                        $(`#select-customer-for-invoice-modal`).modal('hide')
                                    }, 1000)
                                });
                            })
                        },
                        error: (response) => {
                            SaveBtn.stopLoading(false, 'Select').then(() => {
                                SaveBtn.showError('Create customer error!')
                                setTimeout(()=>SaveBtn.hideMessages(),5000)
                            })
                        }
                    })
                }
            } else if (this.customerSelector?.value) {
                let customerName = $(this.customerSelector.element).find(`.input-selector-item[data-value="${this.customerSelector?.value}"]`).text()
                const customerId = this.customerSelector?.value;
                $('#customer-id').val(customerId);
                $('.customer-data-field .data.customer').text(customerName)
                // Save customer_id to localStorage for quote creation
                if (window.location.pathname.includes('/jobs-flow/quote/create')) {
                    localStorage.setItem('quoteCreateCustomerId', customerId);
                }
                $(`#select-customer-for-invoice-modal`).modal('hide')
            }else{
                SaveBtn.showError('Customer not selected!')
                setTimeout(()=>SaveBtn.hideMessages(),5000)
            }
        })
    },

    showRequestInfo(e) {
        const form = $(e.target).parents('.form-container').find('form');
        if(!$('#request-detals').html()) {
            const requestId = form.find('input[name=job_request_id]').val();
            const request = new JobRequest(requestId);
            const formHTML = request.getForm('request', 'view');
            request.pasteForm(formHTML, 'request-detals');

            const requestForm = $('#request-detals').find('.modal');
            requestForm.removeClass('fade');
            requestForm.removeClass('modal');
            requestForm.css('display', 'block');
            requestForm.find('.close-btn, .modal-btn').remove();
            requestForm.find('.modal-content').addClass('border');
            request.completeForm('view-request');
        }

        if ($('#request-detals').css('width') == '550px') {
            $('#request-detals').css({'width': '0px', 'margin-right': '-5px'});
        } else {
            $('#request-detals').css({'width': '550px', 'margin-right': '20px'});
        }
    },

    duplicateInput(event){
        const root = $(event.target).parents('.item');
        const parent = $(event.target).parents('.item-section');
        if(root?.length && parent?.length && (event.target?.name || event.target?.id)){
            const selector = 'input'+event.target?.name ? `[name=${event.target?.name}]` : `#${event.target?.id}`
            const doubleInput = $(root.find(`.item-section`).not(parent)).find(selector);
            if(!doubleInput)
                return
            if(event.target.type == 'checkbox'|| event.target.type=='radio'){
                doubleInput.prop('checked', event.target.checked)
            }else{
                doubleInput.val($(event.target).val())
            }
        }
    },

    async getAddLineForm(formId){
        let result = await PriceBook.getForm(()=>{},'item', 'select');
        if(result){
            $('#invoice-item-form').off('submit.prevent-page-navigation')
                .on('submit.prevent-page-navigation', (event) => event.preventDefault())
            this.itemSelector = new InputSelector('#invoice-item-modal #item-select')
            $('#invoice-item-modal #item-select #create-new-item').on('click', async ()=>{
                await PriceBook.getForm(async (ev)=>{
                    let res = await PriceBook.createOrUpdate(ev)
                    if(res)
                        this.addAnotherLine(formId, res)
                }, 'item', 'create-for-invoice');
                $('#invoice-item-form input[name="name"]').val($(this.itemSelector.inputField).val())
            })
            $('#invoice-item-modal #select').on('click',async (ev)=>{
                let item_id = $(ev.currentTarget).attr('data-id')
                await PriceBook.getForm(async (ev)=>{
                    let data = PriceBook.getDataForInvoice(ev)
                    if(data)
                        this.addAnotherLine(formId, data)
                }, 'item', 'create-for-invoice', {item_id});

                const checkQuantity = () => {
                    let input = $('#invoice-item-form input[name="quantity"]')
                    let value = Number(input.val())
                    if (!value || isNaN(value))
                        $('#invoice-item-form .modal-form-btn').attr('disabled', true)
                    else
                        $('#invoice-item-form .modal-form-btn').attr('disabled', false)
                }
                checkQuantity()
                $('#invoice-item-form input[name="quantity"]').on('input', checkQuantity)
            })
            $(this.itemSelector.element).on('select-item', (ev)=>{
                if(ev.originalEvent.detail.value){
                    $('#invoice-item-modal #select').attr('data-id', ev.originalEvent.detail.value).removeAttr('disabled')
                }
            })
            $(this.itemSelector.element).on('no-data', (ev)=>{
                if(ev.originalEvent.detail.value){
                    $(this.itemSelector.noDataElement).find('.no-data-text').html(`<span>Create new reusable item <b>${ev.originalEvent.detail.value}</b></span>`)
                }
            })
        }
    },

    async openPriceBookBulk(formId){
        let result = await PriceBook.getForm(()=>{}, 'item', 'bulk-select');
        if(!result)
            return;
        const modal = $('#invoice-item-modal');

        const toggleCardQty = ($card, qty) => {
            if(qty > 0){
                $card.addClass('qty-selected');
            }else{
                $card.removeClass('qty-selected');
            }
        };

        const updateSummary = () => {
            let count = 0;
            let total = 0;
            modal.find('.price-book-card').each((_, el)=>{
                const qty = Number($(el).find('.qty-input').val()) || 0;
                toggleCardQty($(el), qty);
                if(qty>0){
                    count += qty;
                    total += qty * Number($(el).data('price'));
                }
            });
            modal.find('#pb-selected-count').text(count);
            modal.find('#pb-selected-total').text(`$ ${total.toFixed(2)}`);
        };

        const clampQty = (input) => {
            let val = Number($(input).val()) || 0;
            if(val < 0) val = 0;
            $(input).val(val);
            return val;
        };

        modal.off('click', '.price-book-card .plus').on('click', '.price-book-card .plus', (ev)=>{
            const input = $(ev.currentTarget).siblings('.qty-input');
            input.val((Number(input.val())||0)+1);
            updateSummary();
        });
        modal.off('click', '.price-book-card .minus').on('click', '.price-book-card .minus', (ev)=>{
            const input = $(ev.currentTarget).siblings('.qty-input');
            const val = Math.max((Number(input.val())||0)-1, 0);
            input.val(val);
            updateSummary();
        });
        modal.off('input', '.price-book-card .qty-input').on('input', '.price-book-card .qty-input', (ev)=>{
            clampQty(ev.currentTarget);
            updateSummary();
        });

        modal.off('input', '.price-book-search').on('input', '.price-book-search', (ev)=>{
            const term = ev.currentTarget.value.toLowerCase();
            const wrapper = $(ev.currentTarget).closest('.price-book-search-wrapper');
            if(term.length){
                wrapper.addClass('has-value');
            }else{
                wrapper.removeClass('has-value');
            }
            modal.find('.price-book-card').each((_, el)=>{
                const name = ($(el).data('name') || '').toString().toLowerCase();
                const desc = ($(el).data('description') || '').toString().toLowerCase();
                if(name.includes(term) || desc.includes(term))
                    $(el).show();
                else
                    $(el).hide();
            });
        });

        modal.off('click', '.price-book-search-wrapper .search-icon').on('click', '.price-book-search-wrapper .search-icon', (ev)=>{
            const input = $(ev.currentTarget).siblings('.price-book-search');
            input.val('');
            $(ev.currentTarget).closest('.price-book-search-wrapper').removeClass('has-value');
            input.trigger('input').focus();
        });

        modal.off('click', '#bulk-select').on('click', '#bulk-select', ()=>{
            const cards = modal.find('.price-book-card').toArray();
            cards.forEach(card=>{
                const $card = $(card);
                const qty = Number($card.find('.qty-input').val()) || 0;
                if(qty <= 0)
                    return;
                // Get image URL from card if exists
                const $cardImg = $card.find('.card-thumb img');
                const imageUrl = $cardImg.length ? $cardImg.attr('src') : null;
                
                const itemData = {
                    id: $card.data('id'),
                    name: $card.data('name'),
                    description: $card.data('description') ?? '',
                    price: Number($card.data('price')),
                    unit_cost: Number($card.data('unit_cost')),
                    type: $card.data('type'),
                    service_type: $card.data('serviceType') ?? $card.data('service-type'),
                    taxable: $card.data('taxable') ? 1 : 0,
                    optional_item: $card.data('optional-item') ? 1 : 0,
                    quantity: qty,
                    image_url: imageUrl
                };
                this.addAnotherLine(formId, itemData);
            });
            modal.modal('hide');
        });

        modal.modal('show');
        updateSummary();
    },

    addAnotherLine(formId, itemData) {

        const lastItem = $(`#${formId}`).find('.item').last();
        const lastIndex = lastItem?.attr('id') ? parseInt(lastItem.attr('id').split('_').pop()) + 1 : 0;
        $(`#${formId}`).append(window.formLine);
        let item = $(`#${formId}`).find('.item').last()
        item.prop('id', `item_${lastIndex}`);
        item.find('.item-name').text(itemData.name)
        item.find('input[name="item"]').val(itemData.name)
        item.find('.item-description').text(itemData?.description ?? '-----------')
        item.find('input[name="details"]').val(itemData?.description ?? '')
        item.find('.item-type').text(itemData?.service_type)
        item.find('input[name="type"]').val(itemData?.type)
        // Set item_id if exists (from Price Book)
        if(itemData?.id) {
            const $itemIdInput = item.find('input[name="item_id"]');
            $itemIdInput.val(itemData.id);
            console.log('Setting item_id in addAnotherLine:', {
                itemData_id: itemData.id,
                input_exists: $itemIdInput.length > 0,
                input_value: $itemIdInput.val(),
                itemData: itemData
            });
        } else {
            console.log('No item_id in itemData:', itemData);
        }
        if(itemData?.taxable)
            item.find('.item-taxable').removeClass('d-none')
        if(itemData?.optional_item)
            item.find('.item-optional').removeClass('d-none')
        item.find('input[name="optional_item"]').val(itemData?.optional_item ? 1 : 0)
        item.find('.form-group.quantity').text(itemData?.quantity ?? '1')
        item.find('input[name="quantity"]').val(itemData?.quantity ?? '1')
        item.find('.form-group.price').text('$ '+Number(itemData?.price).toFixed(2))
        item.find('input[name="cost"]').val(Number(itemData?.price))
        item.find('.form-group.cost').text(itemData?.unit_cost ? '$ '+Number(itemData?.unit_cost).toFixed(2) : '$ 0.00')
        item.find('input[name="unit_cost"]').val(itemData?.unit_cost ?? 0)
        item.find('.form-group.tax').text(itemData?.taxable ? 'Yes' : 'No')
        item.find('input[name="taxable"]').val(itemData?.taxable ? 1 : 0)
        // keep checkboxes in sync so collectFormData reads correctly
        const taxableCheckbox = item.find('input[type="checkbox"][name="taxable"]');
        if (taxableCheckbox.length) {
            taxableCheckbox.prop('checked', !!itemData?.taxable).trigger('change');
        }
        const optionalCheckbox = item.find('input[type="checkbox"][name="optional_item"]');
        if (optionalCheckbox.length) {
            optionalCheckbox.prop('checked', !!itemData?.optional_item).trigger('change');
        }
        
        // Add image if exists (image_url from createOrUpdate or price book; image_path as fallback)
        const imageUrl = itemData?.image_url || (itemData?.image_path ? `/files/${itemData.image_path}` : null);
        if (imageUrl) {
            const $imageContainer = item.find('.form-group.image');
            if ($imageContainer.length) {
                $imageContainer.html(`<img src="${imageUrl}" alt="Preview" class="preview-file-btn" data-src="${imageUrl}" style="max-width: 100px; max-height: 100px; object-fit: contain; cursor: pointer; border-radius: 4px;">`);
            }
        }

        const tax = itemData?.taxable ? Number($('#selected_tax_value').val()) / 100 : 0;
        const taxId = itemData?.taxable ? $('#selected_tax_id').val() : 0;
        if(itemData?.taxable){
            item.find('input[name="tax"]').val($('#selected_tax_value').val())
            item.find('input[name="tax_id"]').val(taxId)
        }

        const basePrice = Number(itemData?.price) * Number(itemData?.quantity);
        const total = basePrice * (1 + tax);
        item.find('.form-group.total').text('$ '+total.toFixed(2));
        this.calculateTotalPriceInForm(formId)
        this.checkIsDisabledBtns(formId)
    },
    removeLine(target) {
        const formId = $(target).parents('form').attr('id');
        $(target).parents('.item').remove();
        this.calculateTotalPriceInForm(formId);
        this.checkIsDisabledBtns(formId)
    },

    updateLine(item,itemData, formId){
        item.find('.item-name').text(itemData.name)
        item.find('input[name="item"]').val(itemData.name)
        item.find('.item-description').text(itemData?.description ?? '-----------')
        item.find('input[name="details"]').val(itemData?.description ?? '')
        item.find('.item-type').text(itemData?.service_type)
        item.find('input[name="type"]').val(itemData?.type)
        if(itemData?.taxable)
            item.find('.item-taxable').removeClass('d-none')
        else
            item.find('.item-taxable').addClass('d-none')
        if(itemData?.optional_item)
            item.find('.item-optional').removeClass('d-none')
        else
            item.find('.item-optional').addClass('d-none')
        item.find('input[name="optional_item"]').val(itemData?.optional_item ? 1 : 0)
        item.find('.form-group.quantity').text(itemData?.quantity ?? '1')
        item.find('input[name="quantity"]').val(itemData?.quantity ?? '1')
        item.find('.form-group.price').text('$ '+Number(itemData?.price).toFixed(2))
        item.find('input[name="cost"]').val(Number(itemData?.price))
        item.find('.form-group.cost').text(itemData?.unit_cost ? '$ '+Number(itemData?.unit_cost).toFixed(2) : '$ 0.00')
        item.find('input[name="unit_cost"]').val(itemData?.unit_cost ?? 0)
        item.find('.form-group.tax').text(itemData?.taxable ? 'Yes' : 'No')
        item.find('input[name="taxable"]').val(itemData?.taxable ? 1 : 0)
        const tax = itemData?.taxable ? Number($('#selected_tax_value').val()) / 100 : 0;
        const taxId = itemData?.taxable ? $('#selected_tax_id').val() : 0;
        if(itemData?.taxable){
            item.find('input[name="tax"]').val($('#selected_tax_value').val())
            item.find('input[name="tax_id"]').val(taxId)
        }else{
            item.find('input[name="tax"]').val('')
            item.find('input[name="tax_id"]').val('')
        }

        const basePrice = Number(itemData?.price) * Number(itemData?.quantity);
        const total = basePrice * (1 + tax);
        item.find('.form-group.total').text('$ '+total.toFixed(2));

        this.calculateTotalPriceInForm(formId)
        this.checkIsDisabledBtns(formId)
    },

    editLine(target){

        const formId = $(target).parents('form').attr('id');
        const item = $($(target).parents('.item')[0])
        const itemId = item.find('input[name="item_id"]').val(); // Get InvoiceItem ID
        
        PriceBook.getForm(async (ev)=>{
            let data = PriceBook.getDataForInvoice(ev)
            if(data)
                this.updateLine(item, data, formId)
        }, 'item', 'update-for-invoice', itemId ? {item_id: itemId} : {}).then(()=>{
            let data = {}
            data.name = item.find('input[name="item"]').val()
            data.description = item.find('input[name="details"]').val()
            data.type = item.find('input[name="type"]').val()
            data.quantity = item.find('input[name="quantity"]').val()
            data.price = item.find('input[name="cost"]').val()
            data.unit_cost = item.find('input[name="unit_cost"]').val()
            data.taxable = item.find('input[name="taxable"]').val() == '1'
            data.optional_item = item.find('input[name="optional_item"]').val() == '1'

            $('#invoice-item-modal input[name="name"]').val(data.name)
            $(`#invoice-item-modal select[name="type"] option[value=${data.type}]`).attr('selected','selected')
            $('#invoice-item-modal input[name="quantity"]').val(data.quantity)
            $('#invoice-item-modal input[name="price"]').val(data.price)
            $('#invoice-item-modal input[name="unit_cost"]').val(data.unit_cost)
            $('#invoice-item-modal textarea[name="description"]').val(data.description)
            if(data.taxable)
                $('#invoice-item-modal input[name="taxable"]').prop('checked',true)
            if(data.optional_item)
                $('#invoice-item-modal input[name="optional_item"]').prop('checked',true)
            
            // Check if image exists and disable upload button
            if (typeof PriceBook !== 'undefined' && PriceBook.updateUploadButtonState) {
                PriceBook.updateUploadButtonState();
            }
        });
    },

    calculateTotalPriceInForm: (formId=null) => {
        if(!formId) formId = $(event.target).parents('form').attr('id');
        const itemRows = $(`#${formId} .item`);

        let subTotalPrice = 0;
        let tax = 0;

        const baseTax = Number($('#selected_tax_value').val());
        const taxId = $('#selected_tax_id').val();

        for (let itemRow of itemRows) {
            itemRow = $(itemRow);

            let quantity = Number(itemRow.find('input[name="quantity"]').val())
            let taxable = itemRow.find('input[name="taxable"]').val() == '1'
            let price = Number(itemRow.find('input[name="cost"]').val())
            let acceptTax=0
            if(taxable){
                itemRow.find('input[name="tax"]').val(baseTax)
                itemRow.find('input[name="tax_id"]').val(taxId)
                acceptTax = baseTax/100
            }else{
                itemRow.find('input[name="tax"]').val('')
                itemRow.find('input[name="tax_id"]').val('')
            }

            subTotalPrice += price * quantity;
            const itemTax = taxable ? (price * quantity)*acceptTax : 0;
            const total = (price * quantity)+itemTax
            itemRow.find('.form-group.total').text('$ '+total.toFixed(2));
            tax += itemTax;

        }

        const totalPrice = subTotalPrice + tax;
        
        $(`#${formId}-container .output .sub-total .value`).text(`$ ${subTotalPrice.toFixed(2)}`);
        $(`#${formId}-container .output .tax .value`).text(`$ ${tax.toFixed(2)}`);
        
        // Trigger custom event for deposit validation
        $(document).trigger('totalRecalculated', [formId, totalPrice]);
        
        // Calculate and update deposit if it exists and is in percentage
        // Try multiple selectors to find deposit fields
        const depositValueInput = $(`#${formId}-container`).find('[name=down_payment]').first();
        const depositTypeInput = $(`#${formId}-container`).find('[name=down_payment_type]').first();
        
        // Fallback to global search if not found in container
        const depositValue = depositValueInput.length > 0 ? depositValueInput.val() : $('[name=down_payment]').val();
        const depositType = depositTypeInput.length > 0 ? depositTypeInput.val() : ($('[name=down_payment_type]').val() || 'dollar');
        
        const depositRow = $(`#${formId}-container .output .deposit`);
        
        if (depositValue && depositValue !== '' && depositValue !== null && parseFloat(depositValue) > 0) {
            let depositAmount = 0;
            if (depositType === 'percent') {
                // Calculate deposit from percentage
                depositAmount = (totalPrice * parseFloat(depositValue)) / 100;
            } else {
                // Fixed dollar amount
                depositAmount = parseFloat(depositValue);
            }
            
            depositRow.show().find('.value').text(`$ ${depositAmount.toFixed(2)}`);
        } else {
            // Show $ 0.00 when no deposit is set
            depositRow.show().find('.value').text(`$ 0.00`);
        }
        
        $(`#${formId}-container .output .total .value`).text(`$ ${totalPrice.toFixed(2)}`);
    },

    checkIsDisabledBtns(formId){
        let serviceId = $('.custom-select-new #service_id').val() != '0'
        let customerId = $('#customer-id').val()
        let itemsCount = $(`#${formId} .item`).length

        if(serviceId && customerId && itemsCount){
            $('.btn-controls #edit, .btn-controls #create').attr('disabled', false);
            $('.btn-controls #edit-sms, .btn-controls #create-sms').attr('disabled', false);
            $('.btn-controls #preview').attr('disabled', false);
            $('.btn-controls #save-draft').attr('disabled', false);
        }else{
            $('.btn-controls #edit, .btn-controls #create').attr('disabled', true);
            $('.btn-controls #edit-sms, .btn-controls #create-sms').attr('disabled', true);
            $('.btn-controls #preview').attr('disabled', true);
            $('.btn-controls #save-draft').attr('disabled', true);
        }
    },

    collectDataInForm: (formId) => {

        let tax_id = null;

        if ($('form .item>input[name=taxable][value="1"]').length > 0 && $('#selected_tax_id').val() !== "") {
            tax_id = $('#selected_tax_id').val();
        }

        let data = {
            items: [],
            job_request_id: $('[name=job_request_id]').val(),
            id: $('.entity_id').val(),
            tax_id: tax_id,
        }
        const items = $(`#${formId} .item`);
        for (let item of items) {
            const itemJQ = $(item);
            let itemData = {
                id: itemJQ.find(`input[name=id]`).val() || null,
                item_id: itemJQ.find(`input[name=item_id]`).val() || null,
                item: itemJQ.find(`input[name=item]`).val(),
                details: itemJQ.find(`input[name=details]`).val(),
                quantity: itemJQ.find(`input[name=quantity]`).val(),
                cost: itemJQ.find(`input[name=cost]`).val(),
                unit_cost: itemJQ.find(`input[name=unit_cost]`).val(),
                type: itemJQ.find(`input[name=type]`).val(),
                taxable: Boolean(Number(itemJQ.find(`input[name=taxable]`).val())),
                optional_item: Boolean(Number(itemJQ.find(`input[name=optional_item]`).val()))
            }
            let taxable = itemJQ.find('.form-group.tax').text().trim() == 'Yes'
            itemData.tax_id = taxable ? $('#selected_tax_id').val() ?? null : null,
            data.items.push(itemData);
        }

        $('input[name=expiration_date]').length && (data.expiration_date = $('input[name=expiration_date]').val());
        if ($('input[name=down_payment]').val()) {
            data.down_payment = $('input[name=down_payment]').val();
        }
        if ($('input[name=down_payment_type]').val()) {
            data.down_payment_type = $('input[name=down_payment_type]').val();
        }
        if ($('input[name=down_payment_non_refundable]').length) {
            const nonRefundableVal = $('input[name=down_payment_non_refundable]').val();
            data.down_payment_non_refundable = (nonRefundableVal !== '' && nonRefundableVal !== null && nonRefundableVal !== undefined) ? nonRefundableVal : '0';
        }
        if ($('input[name=down_payment_set_for_future]').length) {
            const setForFutureVal = $('input[name=down_payment_set_for_future]').val();
            data.down_payment_set_for_future = (setForFutureVal !== '' && setForFutureVal !== null && setForFutureVal !== undefined) ? setForFutureVal : '0';
        }
        $('input[name=start_date_time]').length && (data.start_date_time = $('input[name=start_date_time]').val());
        $('input[name=due_days]').val() && (data.due_days = $('input[name=due_days]').val());
        $('input[name=late_fee_percent]').val() && (data.late_fee_percent = $('input[name=late_fee_percent]').val());
        $('input[name=quote_id]').val() && (data.quote_id = $('input[name=quote_id]').val());
        $('input[name=completion_date]').length && (data.completion_date = $('input[name=completion_date]').val());
        $('input[name=quote_date]').length && (data.quote_date = $('input[name=quote_date]').val());
        
        // Collect design_template_id for quotes
        if ($('input[name=design_template_id]').length) {
            const designTemplateId = $('input[name=design_template_id]').val();
            if (designTemplateId) {
                data.design_template_id = designTemplateId;
            }
        }

        if (!data.job_request_id) {
            data.customer_id = $('#customer-id').val();
            data.service_id = $('[name=service_id]').val();
        }

        return data;
    },

    preview(formId) {
        const data = this.collectDataInForm(formId);
        const jsonString = JSON.stringify(data);
        // btoa() only supports Latin1; encode UTF-8 (e.g. Cyrillic) for base64
        const params = btoa(unescape(encodeURIComponent(jsonString)));
        const entityClass = formId.split('-')[1];
        const previewUrl = `/jobs-flow/${entityClass}/preview`;

        $.ajax({
            url: previewUrl,
            method: 'POST',
            data: { data: params },

            success: (response) => {
                localStorage.setItem(`${entityClass}_preview_data`, response);
                window.open(previewUrl, '_blank');
            }
        })

    },
}
